import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SelectionInfoComponent } from '../../../../modals/selection-info/selection-info.component';
import { meetingData_pObj } from '../../../../services/payload/meetingData_pobj'
import { BettingServiceService } from '../../../../services/betting_service/betting-service.service';
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { AlertController } from '@ionic/angular';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { EventInfoComponent } from "../../../../modals/event-info/event-info.component";
import { meetingMeta_pObj, meetingMeta_greyHound_pObj } from '../../../../services/payload/meetingMeta_pobj';
import { element } from 'protractor';

@Component({
  selector: 'app-all-racing-odds',
  templateUrl: './all-racing-odds.component.html',
  styleUrls: ['./all-racing-odds.component.scss'],
})
export class AllRacingOddsComponent implements OnInit {

  @Input() selectedBetCategory: any;
  ODDs: any = [];
  viewSelectionBlock: boolean;
  selectedMeeting: any;
  selectedEventODD: any = [];

  metaEventLable: any;
  metaEventName: any;
  metaEventLocalDate: any;
  metaeventTime: any;
  shownRule: any;
  is_logged: boolean = false;
  scrollId: string;

  constructor(
    public modalController: ModalController,
    private bettingService: BettingServiceService,
    private commanService: CommonServiceService,
    public alertController: AlertController,public ele: ElementRef,
    private stmgService: StmgService,public renderer: Renderer2
  ) { }

  ngOnInit() {
    this.viewSelectionBlock = false;
    this.stmgService.cast_clickStatus.subscribe(clicked => {
      this.viewSelectionBlock = clicked
      if(!clicked){
        let el = document.getElementById(this.scrollId);
        setTimeout(() => {
          if(el){el.scrollIntoView();}
        }, 100);
      }
    });
    this.is_no_data = false;

    this.stmgService.nav2allRaceRefresh_status.subscribe(clicked => {
      if (clicked == 'yes') {
        this.ngOnChanges();
      }
    });
  }


  ngOnChanges() {
    this.ODDs = [];
    this.viewSelectionBlock = false;
    this.getMeetingData(this.selectedBetCategory);
    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );
    this.is_no_data = false;
  }

  viewRaceDetails(d: any,event) {
    let myTag = this.ele.nativeElement.querySelectorAll(".sub-item");
      myTag.forEach(ele => {
        ele.classList.remove('sub-item-selected');
      })

    let element=event.target;
    for (let index = 0; index < 10; index++) {
      if (element.classList.contains('sub-item')){
        this.renderer.addClass(element, 'sub-item-selected');
        break;
      }else{
        element=element.parentNode;
      }
    }

    this.viewSelectionBlock = true;
    this.selectedMeeting = d;

  }

  viewInfoDetails(event) {
    this.bettingService.getEventMetaData(event.id).subscribe(result => {
      this.PopUpEventInfoModel(event, result)
    },
      error => {
        //console.log("EE:", error);
      });

  }

  async PopUpEventInfoModel(event, metaData) {
    const modal = await this.modalController.create({
      component: EventInfoComponent,
      componentProps: {
        metaData: metaData,
        event: event
      },
      cssClass: 'customPopup'
    });
    return await modal.present();
  }


  getInfoDeatils(infoID) {
    this.bettingService.getEventMetaData(infoID).subscribe(
      (data) => {
        this.setMeetingMetaData(data);
      },
      (error) => { }
    );

  }

  setMeetingMetaData(data) {
    if (this.selectedBetCategory.name != 'UK Greyhounds')
      if (!data.length) {
        var meta_data = new meetingMeta_pObj();

        meta_data.eventLable = this.metaEventLable;
        meta_data.eventName = this.metaEventName;
        meta_data.eventLocalDate = this.metaEventLocalDate;
        meta_data.eventTime = this.metaeventTime;
        this.popUpviewInfoDetails(meta_data);
      }
      else {
        var meta_data = new meetingMeta_pObj();

        meta_data.eventLable = this.metaEventLable;
        meta_data.eventName = this.metaEventName;
        meta_data.eventLocalDate = this.metaEventLocalDate;
        meta_data.eventTime = this.metaeventTime;
        meta_data.track_type = data.eventMetaData.trackType;
        meta_data.going = data.eventMetaData.going;
        meta_data.trifecta = data.eventMetaData.trifecta;
        meta_data.raceType = data.eventMetaData.raceType;
        meta_data.handicap = data.eventMetaData.handicap;
        meta_data.maxrunners = data.eventMetaData.maxrunners;
        meta_data.amount = data.eventMetaData.addedMoneyAmount;
        meta_data.eligibilty_type = data.eventMetaData.eligibilty_type;
        meta_data.distance = data.eventMetaData.distance;
        meta_data.lastWinnerHorsePrice = data.eventMetaData.lastWinnerHorsePrice;
        meta_data.lastWinnerYear = data.eventMetaData.lastWinnerYear;
        meta_data.lastWinnerHorse = data.eventMetaData.lastWinnerHorse;
        meta_data.lastWinnerHorseWeightText = data.eventMetaData.lastWinnerHorseWeightText;
        meta_data.lastWinnerRan = data.eventMetaData.lastWinnerRan;
        meta_data.lastWinnerHorseTrainerName = data.eventMetaData.lastWinnerHorseTrainerName;
        meta_data.lastWinnerHorseJockeyName = data.eventMetaData.lastWinnerHorseJockeyName;
        meta_data.lastWinnerHorseAgeYears = data.eventMetaData.lastWinnerHorseAgeYears;
        this.popUpviewInfoDetails(meta_data);

      }
    else if (this.selectedBetCategory.name == 'UK Greyhounds') {
      // if (!data.length) {
      if (Object.entries(data).length === 0) {
        var meta_data = new meetingMeta_pObj();

        var meta_data_greyhound = new meetingMeta_greyHound_pObj();

        meta_data_greyhound.selectedBetCategory = this.selectedBetCategory.name;
        meta_data_greyhound.eventLable = this.metaEventLable;
        meta_data_greyhound.eventName = this.metaEventName;
        meta_data_greyhound.eventLocalDate = this.metaEventLocalDate;
        meta_data_greyhound.eventTime = this.metaeventTime;
        this.popUpviewInfoDetails(meta_data_greyhound);
      }
      else {
        var meta_data_greyhound = new meetingMeta_greyHound_pObj()

        meta_data_greyhound.selectedBetCategory = this.selectedBetCategory.name;
        meta_data_greyhound.eventLable = this.metaEventLable;
        meta_data_greyhound.eventName = this.metaEventName;
        meta_data_greyhound.eventLocalDate = this.metaEventLocalDate;
        meta_data_greyhound.eventTime = this.metaeventTime;
        meta_data_greyhound.greyhound_type = data.eventMetaData.type;
        meta_data_greyhound.greyhound_class = data.eventMetaData.class;
        meta_data_greyhound.greyhound_handicap = data.eventMetaData.handicap;
        meta_data_greyhound.greyhound_distance = data.eventMetaData.distance;
        this.popUpviewInfoDetails(meta_data_greyhound);
      }
    }
  }

  async popUpviewInfoDetails(metaData) {
    const modal = await this.modalController.create({
      component: EventInfoComponent,
      cssClass: 'customPopup',
      componentProps: { metaData },
    });
    return await modal.present();
  }

  // Get Meeting Data
  getMeetingData(data: any) {
    let meetingPayload = new meetingData_pObj();
    meetingPayload.country = data.country;
    meetingPayload.date = this.commanService.getCurrentDateTime();
    meetingPayload.filter = data.filter;
    meetingPayload.inplay = data.inplay;
    meetingPayload.sport = data.sport;

    this.bettingService.getMeetingData(meetingPayload).subscribe(data => {
      this.validatePayload(data);
    }, (error) => {

    });
  }

  // Get Meeting Data by ID
  getMeetingDataById(id: any,meetingLocalTime) {
    this.shownRule = '';
    if (this.isOddShown(id)) {
      this.shownRule = null;
    } else {
      this.shownRule = id;

      let meetingPayload = new meetingData_pObj();
      meetingPayload.country = this.selectedBetCategory.country;
      meetingPayload.date = this.commanService.getCurrentDateTime();
      meetingPayload.filter = this.selectedBetCategory.filter;
      meetingPayload.inplay = this.selectedBetCategory.inplay;
      meetingPayload.sport = this.selectedBetCategory.sport;
      meetingPayload.id = id;

      this.bettingService.getMeetingDataById(meetingPayload).subscribe(data => {
        this.getSelectedEventOdd(data,meetingLocalTime);
      }, (error) => {

      });
    }
  }
  isOddShown(id) {
    return this.shownRule === id;
  }

  is_no_data = false;
  validatePayload(data: any) {
    if (data.status !== 'success' || !data.payload.length) {
      this.is_no_data = true;
    } else {
      this.meetingOdds(data)
      this.updateMeetingDataSTMG(data);
    }
  }

  meetingOdds(data: any) {
    let tempData = data.payload;
    for (let i = 0; i < tempData.length; i++) {
      this.ODDs[i] = {
        id: tempData[i].id,
        meetingCode: tempData[i].meetingCode,
        meetingLocalTime: tempData[i].meetingLocalTime,
        meetingName: tempData[i].meetingName,
        sortKey: tempData[i].sortKey,
      }
    }
  }

  updateMeetingDataSTMG(d: any) {
    this.stmgService.updateMeetingData(d);
  }

  getSelectedEventOdd(data: any,meetingLocalTime) {
    //check with local date
    let tempData = data.payload[0].eventLightDTOs;
    data.payload.forEach(element => {
      if(element.meetingLocalTime==meetingLocalTime){
        tempData=element.eventLightDTOs;
      }
    });
    
    this.selectedEventODD=[];
    for (let i = 0; i < tempData.length; i++) {
      this.selectedEventODD[i] = {
        cat: tempData[i].cat,
        eventCode: tempData[i].eventCode,
        eventLabel: tempData[i].eventLabel,
        eventLocalDate: tempData[i].eventLocalDate,
        eventName: tempData[i].eventName,
        eventTime: this.commanService.trimEventTime(tempData[i].eventTime),
        id: tempData[i].id,
        meetingCat: tempData[i].meetingCat,
        meetingName: tempData[i].meetingName
      }
    }

  }

  colorChange(event,i){
    this.scrollId="scrollto"+i

    let myTag = this.ele.nativeElement.querySelectorAll(".betting-category");
      myTag.forEach(ele => {
        ele.classList.remove('selected');
      })

    let element=event.target;
    for (let index = 0; index < 10; index++) {
      if (element.id == "dropdown"){
        this.renderer.addClass(element, 'selected');
        break;
      }else{
        element=element.parentNode;
      }
    }
  }



}
